import React from "react";

// Import react-circular-progressbar module and styles
import {
  CircularProgressbar,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// import ChangingProgressProvider from "./ChangingProgressProvider";



const Speedometer =  ({ value, color, textColor }) => (   
     
          <CircularProgressbar
            value={value}
            text={value}
            circleRatio={0.50}
            strokeWidth={18}
            styles={buildStyles({
                rotation: 1 / 2 + 1 / 4,
                strokeLinecap: "butt",
                trailColor: "#eee",
                textColor: textColor, 
                textSize: '16px',
                pathColor: color,

            })}
          />
);
export default Speedometer;


